import { useQuery } from '@tanstack/react-query';
import { getUserStats } from '@/apis/admin';
import { QUERY_KEY } from '@/constants/queryKey';
import Text from '@/components/common/Text';
import * as S from './style';

const UserStats = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QUERY_KEY.ADMIN.USER_STATS],
    queryFn: () => getUserStats(),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  if (isLoading) {
    return <Text>로딩 중...</Text>;
  }

  if (isError) {
    return (
      <S.ErrorText>
        통계 조회 실패: {error instanceof Error ? error.message : '알 수 없는 오류'}
      </S.ErrorText>
    );
  }

  const stats = data?.data;

  if (!stats) {
    return null;
  }

  return (
    <S.StatsContainer>
      <S.StatItem>
        <Text fontWeight={600}>전체:</Text>
        <Text fontWeight={700}>{stats.total}</Text>
      </S.StatItem>
      <S.StatItem>
        <Text fontWeight={600}>구독중:</Text>
        <Text fontWeight={700}>{stats.active}</Text>
      </S.StatItem>
      <S.StatItem>
        <Text fontWeight={600}>무료:</Text>
        <Text fontWeight={700}>{stats.free}</Text>
      </S.StatItem>
      <S.StatItem>
        <Text fontWeight={600}>만료됨:</Text>
        <Text fontWeight={700}>{stats.expired}</Text>
      </S.StatItem>
      <S.StatItem>
        <Text fontWeight={600}>총 작업자 수:</Text>
        <Text fontWeight={700}>{stats.total_workers.toLocaleString()}명</Text>
      </S.StatItem>
      <S.StatItem>
        <Text fontWeight={600}>관리자:</Text>
        <Text fontWeight={700}>{stats.admin_count}</Text>
      </S.StatItem>
    </S.StatsContainer>
  );
};

export default UserStats;

